import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function ClosingSection() {
  return <section className="py-14 md:py-24 px-6 bg-charcoal text-cream" data-id="element-32">
      <div className="max-w-4xl mx-auto text-center" data-id="element-33">
        <h2 className="text-3xl md:text-5xl font-bold mb-10 md:mb-16 font-serif" data-id="element-34">
          Tienes dos caminos hoy:
        </h2>

        <div className="grid md:grid-cols-2 gap-5 md:gap-8 mb-10 md:mb-16" data-id="element-35">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 p-6 md:p-8 rounded-2xl border border-red-500/20 text-left" data-id="element-36">
            <XCircle className="w-10 h-10 text-red-400 mb-4 md:mb-6" data-id="element-37" />
            <p className="text-lg text-cream/80 leading-relaxed" data-id="element-38">
              Seguir acumulando botes caros en tu baño y esperar que "esta vez
              sí funcione" (mientras tu dinero y tu colágeno se agotan).
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 md:p-8 rounded-2xl border border-gold text-left relative overflow-hidden" data-id="element-39">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 rounded-full blur-3xl" data-id="element-40"></div>
            <CheckCircle2 className="w-10 h-10 text-gold mb-4 md:mb-6 relative z-10" data-id="element-41" />
            <p className="text-lg text-cream leading-relaxed relative z-10 font-medium" data-id="element-42">
              Aprender la ciencia real por solo $11.99 y tomar el control total
              de tu apariencia para los próximos 20 años.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-43">
          <CTAButton className="text-lg py-5 px-8 md:px-12 w-full md:w-auto shadow-gold/20 shadow-2xl" data-id="element-44">
            SÍ, QUIERO MI PIEL DE PORCELANA — ACCESO INMEDIATO POR $11.99
          </CTAButton>
          <p className="mt-6 text-cream/40 text-sm" data-id="element-45">
            Pago único. Acceso de por vida.
          </p>
        </motion.div>
      </div>
    </section>;
}